import './pending-process-page.scss';
import { PendingProcessDetails } from '@components/pending-process/details/pending-process-details';
import { PendingProcessHeader } from '@components/pending-process/header/pending-process-header';
import { HeaderIcon } from '@components/pending-process/header-icon/header-icon';
import { ProcessLastActivity } from '@components/pending-process/last-activity/process-last-activity';
import { ProcessProgress } from '@components/pending-process/process-progress/process-progress';
import { ProcessErrorBoundary } from '@components/process-error-boundary/process-error-boundary';
import { Tag } from '@eika/tag';
import { useTranslation } from '@translations';

export const PendingProcessPage = () => {
    const { pendingProcess } = useTranslation();

    return (
        <div className="pending-process-container">
            <HeaderIcon />
            <ProcessErrorBoundary>
                <PendingProcessHeader />
                <Tag type="info">{pendingProcess.tag}</Tag>
                <div className="pending-process-details">
                    <ProcessProgress />
                    <ProcessLastActivity />
                    <PendingProcessDetails />
                </div>
            </ProcessErrorBoundary>
        </div>
    );
};
